import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Countdown from 'react-countdown';
import CountDownModal from '../countdown/countdown';
import LoginModal from '../login/LoginModal';
import WalletConnectBtn from '../nft/WalletConnectBtn';
const HeroCarouselContentSlide = (props) => {
    var _a;
    const { t } = useTranslation();
    const { slideData, modalImage, mute, setMute } = props;
    const linkOnImage = () => {
        let linkToreturn = '';
        switch (slideData.boxLink) {
            case 'First':
                linkToreturn = slideData.link;
                break;
            case 'Second':
                linkToreturn = slideData.secondCtaLink;
                break;
            case 'Third':
                linkToreturn = slideData.thirdCtaLink;
                break;
            case 'Custom':
                linkToreturn = slideData.customBoxLink || '';
                break;
            default:
                break;
        }
        if (linkToreturn !== '') {
            return React.createElement("a", { href: linkToreturn, className: "hero-box__link" });
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const singleCta = (url, text, analyticsData) => {
        return (React.createElement("a", { href: url, className: "button button--tertiary-inverted button--arrow-right", "data-analytics": analyticsData }, text));
    };
    const regularCtas = () => {
        return (React.createElement(React.Fragment, null,
            slideData.link && singleCta(slideData.link, slideData.linkText),
            slideData.secondCtaLink && singleCta(slideData.secondCtaLink, slideData.secondCtaText),
            slideData.thirdCtaLink && singleCta(slideData.thirdCtaLink, slideData.thirdCtaText)));
    };
    const lockCtas = () => {
        if (!props.relatedCustomerGroupsCondition) {
            if (props.lockType !== 'walletLock') {
                return (React.createElement(LoginModal, { customClass: "button button--tertiary-inverted button--arrow-right", analyticsKey: "earlyAccess", buttonText: slideData.notloggedCTAText, customModalId: slideData.customModalId, buttonTextAnalytics: slideData.buttonTextAnalytics, reloadPage: slideData.redirectUrl && !slideData.countdown_active, linkreload: !slideData.countdown_active && slideData.redirectUrl }));
            }
            else {
                return (React.createElement(WalletConnectBtn, { btnClass: "button button--tertiary-inverted button--arrow-right", connectBtnLabel: "walletconnect.btn.unlock", hideDisconnectBtn: true, analyticsCategory: "early access", analyticsAction: "unlock with wallet connect", analyticsLabel: "fragment" }));
            }
        }
        else {
            return singleCta(slideData.link, slideData.linkText, '{"event": "flp", "eventCategory": "early access", "eventAction": "discover the collection" , "eventLabel" : "fragment" }');
        }
    };
    const renderCtas = () => {
        if (slideData.lockCTAs) {
            return lockCtas();
        }
        else {
            return regularCtas();
        }
    };
    const slideLabel = () => {
        return (React.createElement("span", { className: classNames('hero-column__label', { 'primary-l-u': slideData.title_typo == 'BlockGothicRR' }, { 'primary-s-u': slideData.title_typo != 'BlockGothicRR' }), "data-aos": 'fade-up-10' }, slideData.label));
    };
    const countdownTitle = () => {
        return (React.createElement("span", { className: classNames('hero-column__title', 'primary-xxl', 'primary-m-u'), "data-aos": 'fade-up-15' },
            React.createElement(Countdown, { date: slideData.countdown_date.value, onComplete: () => {
                    if (slideData.redirectUrl) {
                        window.location.href = slideData.redirectUrl;
                    }
                }, renderer: ({ days, hours, minutes, seconds, completed }) => (React.createElement(React.Fragment, null, completed ? (`${slideData.title} `) : (React.createElement(React.Fragment, null,
                    days,
                    "D:",
                    hours < 10 ? `0${hours}` : hours,
                    "H:",
                    minutes < 10 ? `0${minutes}` : minutes,
                    "M:",
                    seconds < 10 ? `0${seconds}` : seconds,
                    "S")))) })));
    };
    const slideTitle = () => {
        return (slideData.title && (React.createElement("span", { className: classNames('hero-column__title', { 'hero-column__title--bigger': slideData.title_typo == 'BlockGothicRR' }, { 'primary-xxl': slideData.title_typo != 'BlockGothicRR' }, { 'primary-l-u': slideData.title_typo == 'BlockGothicRR' }, { 'primary-m-u': slideData.title_typo != 'BlockGothicRR' }), "data-aos": 'fade-up-15' }, slideData.title)));
    };
    return (React.createElement("div", { className: classNames('hero-column__content-container') },
        linkOnImage,
        slideData.label && slideLabel(),
        slideData.countdown_active && ((_a = slideData.countdown_date) === null || _a === void 0 ? void 0 : _a.value) ? countdownTitle() : slideTitle(),
        slideData.paragraph && (React.createElement("p", { className: classNames('hero-column__headline', 'spacing'), "data-aos": 'fade-up-20' }, slideData.paragraph.substr(0, 136))),
        (slideData.link || slideData.show_modal) && !slideData.hideCta && (React.createElement("span", { className: classNames('hero-column__cta', { 'hero-column__cta--mobile_block': slideData.link && slideData.secondCtaLink && slideData.thirdCtaLink }), "data-aos": 'fade-up-20' }, slideData.show_modal ? (React.createElement("div", { "data-aos": 'fade-up-20' },
            React.createElement(CountDownModal, { type: "homepage", title: slideData.title, text: slideData.linkText, eventcode: slideData.eventCode, geniuscode: slideData.geniusCode, modaltitle: slideData.modalTitle, modalctatext: slideData.modalCTAText, modaltext: slideData.modalText, buttonClasses: classNames('button', 'button--tertiary-inverted', 'button--arrow-right'), uuid: slideData.id, img: modalImage, classes: ['button--tertiary-inverted', 'button--arrow-right'] }))) : (renderCtas()))),
        slideData.thronID && slideData.volumeToggle && (React.createElement("button", { className: "btn--volume", onClick: () => setMute(!mute), "aria-label": t('button.unmute'), "data-mute": true, "aria-pressed": !mute }))));
};
export default HeroCarouselContentSlide;
